import React from 'react';

import styled from 'styled-components';

import { CompanyAICompetitiveIntelligenceRow } from 'types/recommendations';

const SmallText = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

const CompetitorName = styled.div`
  font-size: 14px;
  color: var(--text-primary);
`;

const CompetitorScore = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 2px;
`;

type Props = {
  competitor: CompanyAICompetitiveIntelligenceRow['top_competitor'];
  scoreLabel: string;
};

const TopCompetitorCell = ({ competitor, scoreLabel }: Props) => {
  if (!competitor?.name) {
    return <SmallText>-</SmallText>;
  }

  return (
    <div>
      <CompetitorName>{competitor.name}</CompetitorName>
      {typeof competitor.score === 'number' && (
        <CompetitorScore>
          {scoreLabel} {competitor.score}/100
        </CompetitorScore>
      )}
    </div>
  );
};

export default TopCompetitorCell;
